export const AppRooms = {
    PRESENCE: 'presence',
    CHAT: 'chat',
}

export const AppNameSpaces = {
    PRESENCE: 'presence-indicator',
    CHAT: 'chat-indicator',
    CHAT_INPUT: 'chat-input',
    NAME: 'doshby-app',
}
